(function () {
    'use strict';

    function workflowMainController() {

    }

    workflowMainController.$inject = [];

    angular.module('ecap.workflow').controller('workflowMainController', workflowMainController);
})();
